import { render } from "./WhyCompaniesNeedDms.vue?vue&type=template&id=84bc7fe4&scoped=true"
import script from "./WhyCompaniesNeedDms.vue?vue&type=script&lang=js"
export * from "./WhyCompaniesNeedDms.vue?vue&type=script&lang=js"

import "./WhyCompaniesNeedDms.vue?vue&type=style&index=0&id=84bc7fe4&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84bc7fe4"]])

export default __exports__